import { useState, useEffect, useRef } from "react";
import { createModel } from "hox";

export const useOrderModel = createModel(function () {
    // const [apiCount, setApiCount] = useState(0)
    const apiCount = useRef(0)
    return {
        apiCount
    }
});